import { INSTAGRAM_PUBLISHING_ENABLED } from './constants';
import { DIRECT_SEND_GATED_TOOL_NAMES } from './directSendTools';
import {
  ALWAYS_CONFIRM_TOOL_NAMES,
  NEVER_PRE_APPROVED_TOOL_NAMES,
} from './directWriteTools';

const INSTAGRAM_PUBLISH_POST_TOOL_NAME = 'instagram_publish_post';

// MUST equal the keys of proposeActionsToolRegistry in agent/worker/handler.ts, in order (handler.spec.ts pins it).
export const PROPOSE_ACTIONS_ROUTED_TOOL_NAMES = [
  'create_dobox',
  'update_dobox',
  'resolve_dobox',
  'accept_dobox_suggestion',
  'move_dobox',
  'move_dobox_to_subgroup',
  'update_dobox_collections',
  'create_dobox_label',
  'update_task_group_participants',
  'add_dobox_comment',
  'get_dobox_comment_upload_url',
  'add_dobox_checklist',
  'add_dobox_subtask',
  'toggle_dobox_subtask',
  'delete_dobox',
  'gbp_reply_review',
  'facebook_reply_comment',
  'facebook_publish_post',
  'act_on_emails',
  'act_on_calendar_invites',
  'create_calendar_event',
  'create_email_label',
  'create_task_group',
  'update_task_group',
  'update_task_label',
  'propose_flow',
  'run_flow_now',
  'propose_custom_agent',
  'request_from_teammate',
  'propose_meeting_times',
  'send_slack_bot_message',
  'send_dobox_source_reply',
  'send_notification_email',
  'execute_create_knowledge_space',
  'execute_rename_knowledge_space',
  'execute_create_knowledge_page',
  'execute_edit_knowledge_page',
  'execute_rename_knowledge_page',
  'execute_delete_knowledge_page',
  'create_dobox_rule',
  'update_dobox_rule',
  'create_recurring_dobox',
  'update_recurring_dobox',
  'create_task_subgroup',
  'update_task_subgroup',
  'delete_task_subgroup',
  'create_person',
  'create_person_event',
  ...(INSTAGRAM_PUBLISHING_ENABLED
    ? ([INSTAGRAM_PUBLISH_POST_TOOL_NAME] as const)
    : ([] as const)),
  'instagram_reply_comment',
  'browser_click',
  'browser_fill',
  'browser_select_option',
  'browser_press_key',
  'persona_correct',
  'memory_remember',
  'memory_update',
  'memory_confirm',
  'memory_retract',
  'persona_set_relation',
  'persona_set_routine',
  'persona_set_voice',
  'persona_set_contact',
] as const;

export type ProposeActionsRoutedToolName =
  (typeof PROPOSE_ACTIONS_ROUTED_TOOL_NAMES)[number];

const EXCLUDED_FROM_PRE_APPROVAL: ReadonlySet<string> = new Set([
  ...DIRECT_SEND_GATED_TOOL_NAMES,
  ...NEVER_PRE_APPROVED_TOOL_NAMES,
  ...ALWAYS_CONFIRM_TOOL_NAMES,
]);

export const PRE_APPROVABLE_WORKSPACE_TOOL_NAMES =
  PROPOSE_ACTIONS_ROUTED_TOOL_NAMES.filter(
    (name) => !EXCLUDED_FROM_PRE_APPROVAL.has(name),
  );
